/* LAGT TIL AV MEG */

/* Accordion Image Gallery */
class AccordionGallery {
  constructor(container) {
    this.container = container;
    this.images = container.querySelectorAll('.accordion-gallery__item img');
    this.lightbox = null;
    this.currentIndex = 0;
    
    if (this.images.length > 0) {
      this.init();
    }
  }
  
init() {
  this.createLightbox();
  this.bindEvents();
  this.bindArrows();
  this.bindLightboxArrows();
}

  
  createLightbox() {
  this.lightbox = document.createElement('div');
  this.lightbox.className = 'accordion-lightbox';
  
  var imagesHTML = '';
  for (var i = 0; i < this.images.length; i++) {
    var img = this.images[i];
    imagesHTML += '<div class="accordion-lightbox__slide"><img src="' + img.src + '" alt="' + (img.alt || '') + '"></div>';
  }
  
  this.lightbox.innerHTML = '<div class="accordion-lightbox__content">' +
    '<button class="accordion-lightbox__close" aria-label="Lukk">&times;</button>' +
    '<button class="accordion-lightbox__arrow accordion-lightbox__arrow--prev" aria-label="Forrige">‹</button>' +
    '<button class="accordion-lightbox__arrow accordion-lightbox__arrow--next" aria-label="Neste">›</button>' +
    '<div class="accordion-lightbox__track">' + imagesHTML + '</div>' +
    '<div class="accordion-lightbox__counter">' +
    '<span class="current">1</span> / <span class="total">' + this.images.length + '</span>' +
    '</div></div>';
  
  document.body.appendChild(this.lightbox);
  this.lightboxTrack = this.lightbox.querySelector('.accordion-lightbox__track');
}

  
  bindEvents() {
    var self = this;
    
    this.images.forEach(function(img, index) {
      img.parentElement.addEventListener('click', function() {
        self.openLightbox(index);
      });
    });
    
    var closeBtn = this.lightbox.querySelector('.accordion-lightbox__close');
    closeBtn.addEventListener('click', function() {
      self.closeLightbox();
    });
    
    this.lightbox.addEventListener('click', function(e) {
      if (e.target === self.lightbox) {
        self.closeLightbox();
      }
    });
    
    this.lightboxTrack.addEventListener('scroll', function() {
      self.updateCounter();
    });
  }
  
  bindArrows() {
    var prevBtn = this.container.querySelector('.accordion-gallery__arrow--prev');
    var nextBtn = this.container.querySelector('.accordion-gallery__arrow--next');
    var track = this.container.querySelector('.accordion-gallery__track');
    
    if (prevBtn && nextBtn && track) {
      prevBtn.addEventListener('click', function() {
        track.scrollBy({ left: -track.offsetWidth, behavior: 'smooth' });
      });
      
      nextBtn.addEventListener('click', function() {
        track.scrollBy({ left: track.offsetWidth, behavior: 'smooth' });
      });
    }
  }

  bindLightboxArrows() {
  var self = this;
  var prevBtn = this.lightbox.querySelector('.accordion-lightbox__arrow--prev');
  var nextBtn = this.lightbox.querySelector('.accordion-lightbox__arrow--next');
  
  if (prevBtn && nextBtn) {
    prevBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      var slideWidth = self.lightboxTrack.offsetWidth;
      self.lightboxTrack.scrollBy({ left: -slideWidth, behavior: 'smooth' });
    });
    
    nextBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      var slideWidth = self.lightboxTrack.offsetWidth;
      self.lightboxTrack.scrollBy({ left: slideWidth, behavior: 'smooth' });
    });
  }
}

  
  openLightbox(index) {
    this.currentIndex = index;
    this.lightbox.classList.add('active');
    document.body.style.overflow = 'hidden';
    
    var slides = this.lightboxTrack.querySelectorAll('.accordion-lightbox__slide');
    if (slides.length > 0) {
      var slideWidth = slides[0].offsetWidth;
      this.lightboxTrack.scrollLeft = slideWidth * index;
    }
    this.updateCounter();
  }
  
  closeLightbox() {
    this.lightbox.classList.remove('active');
    document.body.style.overflow = '';
  }
  
  updateCounter() {
    var slides = this.lightboxTrack.querySelectorAll('.accordion-lightbox__slide');
    if (slides.length > 0) {
      var slideWidth = slides[0].offsetWidth;
      var currentSlide = Math.round(this.lightboxTrack.scrollLeft / slideWidth);
      var currentSpan = this.lightbox.querySelector('.current');
      if (currentSpan) {
        currentSpan.textContent = currentSlide + 1;
      }
    }
  }
}

function initGalleries() {
  var galleries = document.querySelectorAll('.accordion-gallery');
  galleries.forEach(function(gallery) {
    new AccordionGallery(gallery);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initGalleries);
} else {
  initGalleries();
}
